export default __webpack_public_path__ + "static/media/pamediaDark.23cd3740.svg";